<template>
  <v-container fluid>
    <material-card color="green" :title="concessionId ? 'Edit Fee Concession' : 'Create Fee Concession'" inline icon="mdi-mail">
      <a @click="$router.back()">
        <v-btn elevation="1" v-if="$vuetify.breakpoint.smAndUp" absolute right top> <v-icon left>mdi-arrow-left</v-icon>back</v-btn>
        <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10" style="opacity:.6;"> <v-icon>mdi-arrow-left</v-icon></v-btn>
      </a>
      <v-card flat class="px-2">
        <form @submit.prevent="save">
          <v-row>
            <v-col cols="12" md="6" lg="4">
              <span class="body-2 font-weight-medium">Franchisee</span>

              <v-autocomplete
                class="my-0 py-1"
                single-line
                :disabled="concessionId ? true : false"
                v-model="franchiseeArr"
                :items="franchiseeList"
                item-text="companyName"
                item-value="id"
                multiple
                chips
                persistent-hint
              >
                <template v-slot:selection="{ item }">
                  <v-chip small dark class="font-weight-medium" color="darkblue lighten-1">
                    <span>{{ item.companyName }}</span>
                  </v-chip>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col cols="12" md="6" lg="4">
              <span class="body-2 font-weight-medium">Academic Year</span>

              <v-autocomplete
                class="my-0 py-1"
                single-line
                :disabled="concessionId ? true : false"
                v-model="academicYearID"
                :items="yearArr"
                item-text="academicYear"
                item-value="id"
                chips
                persistent-hint
              >
                <template v-slot:selection="{ item }">
                  <v-chip small dark class="font-weight-medium" color="darkblue lighten-1">
                    <span>{{ item.academicYear }}</span>
                  </v-chip>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col cols="12" md="6" lg="4">
              <span class="body-2 font-weight-medium">Name</span>
              <v-text-field class="my-0 py-1" v-model.trim="name" single-line :counter="100" required name="name"> </v-text-field>
            </v-col>

            <v-col cols="12" md="6" lg="4">
              <span class="body-2 font-weight-medium">Fee Type</span>

              <v-autocomplete class="my-0 py-1" single-line :disabled="concessionId ? true : false" v-model="feeType" :items="feeTypeList" item-text="name" item-value="id" chips persistent-hint>
                <template v-slot:selection="{ item }">
                  <v-chip small dark class="font-weight-medium" color="darkblue lighten-1">
                    <span>{{ item.name }}</span>
                  </v-chip>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col cols="12" md="6" lg="4">
              <span class="body-2 font-weight-medium">Mode</span>

              <div class="field">
                <v-radio-group v-model="isPercentage" row>
                  <v-radio selected label="Percentage" :value="true"></v-radio>
                  <v-radio label="Amount" :value="false"></v-radio>
                </v-radio-group>
              </div>
            </v-col>

            <v-col cols="12" md="6" lg="4">
              <span class="body-2 font-weight-medium">{{ isPercentage ? 'Percentage' : 'Amount' }} </span>
              <v-text-field class="my-0 py-1" v-model.trim="amountOrPercentage" single-line :counter="100" required name="name"> </v-text-field>
            </v-col>

            <v-col cols="12">
              <v-card-actions class="d-flex justify-end">
                <v-btn elevation="1" type="submit" color="primary" :class="{ 'is-loading': lock }" :disabled="lock">
                  <v-icon left> mdi-content-save </v-icon>
                  Save
                </v-btn>
              </v-card-actions>
            </v-col>
          </v-row>
        </form></v-card
      >
    </material-card>
    <loading-icon :value="isLoading" />
  </v-container>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
export default {
  components: { MaterialCard },
  props: ['concessionId'],
  data () {
    return {
      isLoading: false,
      lock: false,
      academicYearID: '',
      franchiseeList: [],
      franchiseeArr: [],
      feeTypeList: [],
      yearArr: [],
      amountOrPercentage: '',
      isPercentage: true,
      feeType: '',
      name: ''
    }
  },
  created: async function () {
    await this.getFranchiseeList()
    await this.getFeeTypes()
    await this.getYear()
    if (this.concessionId) {
      await this.getConcessionDetails()
    }
  },
  methods: {
    getConcessionDetails: async function () {
      try {
        this.isLoading = true
        let res = await http.get(`${CONSTANTS.API_URL}/api/fee-concession/student/${this.concessionId}`)
        let data = res.data[0]
        this.franchiseeArr.push(data.franchiseeID)
        this.academicYearID = data.academicYearID
        this.feeType = data.feeTypeID
        this.isPercentage = data.isPercentage
        this.name = data.name
        this.amountOrPercentage = data.amountOrPercentage
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    save: async function () {
      try {
        this.isLoading = true

        let url, formData
        if (this.concessionId) {
          formData = {
            name: this.name,
            amountOrPercentage: this.amountOrPercentage,
            isPercentage: this.isPercentage
          }
          url = `${CONSTANTS.API_URL}/api/fee-concession/student/${this.concessionId}`
        } else {
          formData = {
            franchiseeID: this.franchiseeArr,
            academicYearID: this.academicYearID,
            name: this.name,
            feeTypeID: this.feeType,
            amountOrPercentage: this.amountOrPercentage,
            isPercentage: this.isPercentage
          }
          url = `${CONSTANTS.API_URL}/api/fee-concession/student`
        }

        await http.post(url, formData)
        this.okMsg('Record saved successfully!')
        this.$router.push({ name: 'feeConcession' })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getFranchiseeList: async function () {
      try {
        this.isLoading = true
        const response = await http.get(`${CONSTANTS.API_URL}/api/franchisee/active`)
        this.franchiseeList = response.data.rows
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getFeeTypes: async function () {
      try {
        this.isLoading = true
        const response = await http.get(`${CONSTANTS.API_URL}/api/fee-type`)
        this.feeTypeList = response.data.rows
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getYear: async function () {
      try {
        this.isLoading = true
        const response = await http.get(`${CONSTANTS.API_URL}/api/franchiseeAcademicYears?isCurrentAcademicYear=true`)
        this.yearArr = response.data.rows
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    okMsg (msg) {
      return this.$buefy.dialog.alert({
        type: 'is-success',
        message: msg,
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    }
  }
}
</script>

<style></style>
